<div *ngIf="!mostrarFormulario" class="row animated fadeInRight">
  <!-- *GRID LISTAR ROL -->
  <app-lfsa-card-v2 *ngIf="mostrarGridLista"
                    [innTemplate]="enviarTemplate" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #enviarTemplate>
    <section class="section">
      <form [formGroup]="formulario" class="form-group" novalidate>
        <div class="row">
          <div class="form-group col-md-6">
            <app-lfsa-combo-box
              (change)="listAll()"
              [comboBox]="cmbDepartment"
              [control]="formulario.get('department') | formControl"
              [idOpcion]="'id'" [id]="'department'" [label]="'Departamento*'"
              [opcion]="'descripcion'"
              formControlName="department">
            </app-lfsa-combo-box>
          </div>
        </div>
        <div class="row mb-4">
          <div class="form-group col-md-6">
            <app-lfsa-input (change)="listAll()" [control]="formulario.get('startDate') | formControl"
                            [id]="'startDate'"
                            [label]="'Ingrese Fecha Inicio*'" [mostrarImg]="false" [placeholder]="'Fecha Inicio'"
                            [type]="'date'"
                            formControlName="startDate">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-6">
            <app-lfsa-input (change)="listAll()" [control]="formulario.get('endDate') | formControl"
                            [id]="'endDate'"
                            [label]="'Ingrese Fecha Fin*'" [mostrarImg]="false" [placeholder]="'Fecha Fin'"
                            [rutaImagen]=""
                            [type]="'date'"
                            formControlName="endDate">
            </app-lfsa-input>
          </div>
        </div>
      </form>
      <div *ngIf="formulario.valid" class="row">
        <div class="col-md-12 ">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [columnDefs]="columnDefs"
                           [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
                           [ngStyle]="diccionarioModulo.agGrid.style" [pagination]="true"
                           [rowData]="rowData" [rowSelection]="rowSelection"
                           class="{{diccionarioModulo.agGrid.class}}" id="{{diccionarioModulo.agGrid.id}}"
                           [paginationPageSize]="diccionarioModulo.agGrid.paginacion">
          </ag-grid-angular>
        </div>
      </div>
    </section>
  </ng-template>
</div>
